package nl.volleyplanner.web.util

import kotlinx.browser.document
import kotlinx.browser.window

enum class BootstrapColor(val cssName: String) {
    Primary("primary"),
    Secondary("secondary"),
    Success("success"),
    Danger("danger"),
    Warning("warning"),
    Info("info"),
    Light("light"),
    Dark("dark");

    val textColorClass = "text-$cssName"
    val textBgColorClass = "text-bg-$cssName"
    val linkColorClass = "link-$cssName"

    fun backgroundColorClass(subtle: Boolean) = when(subtle) {
        true -> "bg-$cssName-subtle"
        false -> "bg-$cssName"
    }
}

enum class BootstrapBreakPoint {
    XS, SM, MD, LG, XL, XXL
}

object BootstrapUtil {
    /**
     * xs, sm, md, lg, xl, xxl
     */
    fun getCurrentBreakpoint() : BootstrapBreakPoint {
        val breakpoint = window.getComputedStyle(document.getElementById("bs-breakpoint-helper")!!)
            .getPropertyValue("content")
            .replace("\"", "")

        return BootstrapBreakPoint.valueOf(breakpoint.uppercase())
    }
}